module.exports = __webpack_public_path__ + "img/logo.c41bd716.svg";